<button
    type="button"
    [class]="buttonClass"
    (click)="onNavigateBack()"
    [attr.aria-label]="ariaLabel || returnLabel">
    <i *ngIf="showIcon" [class]="iconClass" aria-hidden="true"></i>
    {{returnLabel}}
</button>
